import { render, staticRenderFns } from "./writers.vue?vue&type=template&id=23c740d9"
import script from "./writers.vue?vue&type=script&lang=js"
export * from "./writers.vue?vue&type=script&lang=js"
import style0 from "./writers.vue?vue&type=style&index=0&id=23c740d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports